import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { CALENDAR_SETTINGS_ROUTES } from "../../modules/constants";

export default () => ({
  path: CALENDAR_SETTINGS_ROUTES.EVENT_TYPES,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "calendar-settings-event-types" */ "./components"
    ).then(m => m.default)
  ),
});
